export default {
  name: 'selectWay',
  props: {
    src: {
      type: String,
      default: ''
    },
    wayType: {
      type: String,
      default: ''
    }
  },
  components: {},
  data: function data() {
    return {};
  },
  methods: {
    selectWay: function selectWay(type) {
      // this.wayType = type;
      this.$emit('selectWay', type);
    }
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {}
};